const wait = ms => new Promise(resolve => { setTimeout(resolve, ms); });

// Only retry transient failures: network error (no response) / 5xx / 429.
// Never retry 4xx (404, 400, …) — a retry cannot fix them and only adds load.
const isRetryable = status => status === undefined || status >= 500 || status === 429;

/**
 * Runs an async request fn, retrying transient failures with exponential backoff.
 * Defaults: 2 retries (3 attempts total) at 300ms, 600ms.
 *
 * @param {() => Promise<any>} fn
 * @param {{ retries?: number, baseDelay?: number }} [options]
 * @returns {Promise<any>}
 */
export default async function retryRequest(fn, { retries = 2, baseDelay = 300 } = {}) {
  try {
    const result = await fn();
    return result;
  } catch (error) {
    if (retries <= 0 || !isRetryable(error?.response?.status)) throw error;
    await wait(baseDelay);
    return retryRequest(fn, { retries: retries - 1, baseDelay: baseDelay * 2 });
  }
}
